<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">
        <div class="form-group row mt-4">
          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6  mb-4">

          <reg-input-select
            v-if="fields[0] && timezones"
            label="Time zone"
            type="number"
            :form="form"
            :field="fields[0]"
            :options="timezones.map((type) => type.timezone)"
            :custom-label="
              (opt) =>
                timezones.find((x) => x.timezone == opt).timezone +
                ' (' +
                timezones.find((x) => x.timezone == opt).offset +
                ')'
            "
            formGroupClass=""
            placeholder="Select Time zone"
            :api-errors="apiErrors"
            :rules="{ required: fields[0].required }"
          />
        </div>

      <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4">


          <reg-input-text
            v-if="fields[1]"
            label="Mobile Number"
            type="number"
            :form="form"
            :field="fields[1]"
            placeholder="Enter Mobile Number"

            formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-1"
            :rules="{ required: fields[1].required, digits: 10 }"
            @inputHandler="handleInput($event, 'mobile_number')"
             @keypress.native="onlyAllowDigits"
             maxlength="10"
             inputmode="numeric"
             pattern="\d*"
          />
                  <span v-if="showOtpSectionMobile" class="validate-btn col-md-5 col-sm-6 d-flex mt-2 rep-mobile-otp-validation">
                  <a href="#" class="validate-via-otp-link " @click.prevent="openOtpModal('mobile')" >
                      TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR MOBILE NUMBER. 
                  </a>
                </span>


                        
                <!-- to show the error message dynamically under the fields -->
                <div v-if="mobileMsg" class="contacts-message-container form-group">
          <div :class="['validate-message mt-2',mobileValidationMessage.type]">
            <div :class="['message-indicator', `${mobileValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${mobileValidationMessage.type}-text`">{{ mobileValidationMessage.title }}</strong> - 
              {{ mobileValidationMessage.message }}
            </span>
          </div>
        </div>

      </div>

        </div>

        <div class="form-group row">
         
          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4">

          <reg-input-text
            v-if="fields[2]"
            label="Phone Number"
            type="number"
            :form="form"
            :field="fields[2]"
            placeholder="Enter Phone Number "
            
            formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-1 w-100"
            :rules="{ required: fields[2].required, digits: 10 }"
            @inputHandler="handleInput($event, 'phone_number')"
               @keypress.native="onlyAllowDigits"
             maxlength="10"
             inputmode="numeric"
             pattern="\d*"
          />
            <span v-if="showOtpSectionPhone" class="validate-btn col-md-5 col-sm-6 d-flex mt-2 rep-phone-otp-validation">
              <a href="#" class="validate-via-otp-link " @click.prevent="openOtpModal('phone')" >
                  TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE. 
              </a>
            </span>
           <div v-if="phoneMsg" class="contacts-message-container form-group">
          <div :class="['validate-message mt-2', phoneValidationMessage.type]">
            <div :class="['message-indicator', `${phoneValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${phoneValidationMessage.type}-text`">{{ phoneValidationMessage.title }}</strong> - 
              {{ phoneValidationMessage.message }}
            </span>
          </div>
        </div>

        </div>

        <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4">
          <reg-input-text
            v-if="fields[3]"
            label="FAX Number"
            type="number"
            :form="form"
            :field="fields[3]"
            placeholder="Enter FAX Number"
            :api-errors="apiErrors"
            formGroupClass=""
            :rules="{ required: fields[3].required, digits: 10 }"
            @inputHandler="handleInput($event, 'fax')"
          />
          </div>

        
        </div>
        <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 ">
            <div class="d-flex align-items-center mb-3">
              <input type="checkbox" class="mb-1" v-model="isChecked" />
              <label class="mb-0 ms-2">Display Phone</label>
            </div>
            <div class="" v-if="isChecked">
              <reg-input-text
                v-if="fields[4]"
                label="Phone Number"
                type="number"
                :form="form"
                 :api-errors="apiErrors"
                :field="fields[4]"
                placeholder="Enter Phone Number"
                formGroupClass="col-xxl-12 col-xl-12 col-lg-12 col-md-12 mb-4"
                :rules="{ required: fields[2].required, digits: 10 }"
                @inputHandler="handleInput($event, 'display_phone')"
                   @keypress.native="onlyAllowDigits"
             maxlength="10"
             inputmode="numeric"
             pattern="\d*"
              />
            </div>

          </div>
          <!-- web access -->
          <reg-input-text
            v-if="fields[5]"
            label="Web Access"
            :form="form"
            :field="fields[5]"
            placeholder="Enter web access"
            :api-errors="apiErrors"
            formGroupClass="col-xxl-12 col-xl-12 col-lg-12 col-md-12 mb-4"
            :rules="{ required: fields[5].required, alpha_num: true }"
            @keypress.native="onlyAllowAlphanumeric"
          />
        <div class="action-btn split-action mt-5">
          <button type="button" class="button-back" @click="backHandler">Back</button>
          <div class="action-next">
            <button class="button-save" @click.prevent="saveAndContinue" type="button">
              Save & Continue Later
            </button>
            <button class="button-submit" type="submit">Next</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
     <RegistrationOTPModal
    v-if="showOtpModal"
    v-model="showOtpModal"
    :identifier="contactInfo"
    :identifierTypeText="otpType"
    :field="field"
    @save="handleVerificationResult"
    @close="closeOtpModal"
/>

    <!-- <verify-phone-email-modal inputType="phone" /> -->
  </div>
</template>
<script>
import Api from "@/resource/Api";
import Cookies from "js-cookie";

import axios from "@/utils/regAxios";
import RegInputRadio from "../utils/RegInputRadio.vue";
import ScreenShot from "@/utils/screenshot";
// import VerifyPhoneEmailModal from "../../MemberList/modal/VerifyPhoneEmailModal.vue";
import RegistrationOTPModal from "../modal/RegistrationOTPModal.vue";


export default {
  name: "ContactForm",
  components: {
    RegistrationOTPModal,
  },
  props: {
    fields: {
      required: true,
    },
    form: {
      required: true,
    },
    timezones: {
      required: true,
    },
  },
  data: () => ({
    apiErrors: null,
    components: { RegInputRadio },
    isChecked: false,

  
    showOtpModal: false,
    showOtpSectionPhone: false,


    contactInfo: null,
    otpType: null,
    field: null,
    // emailMsg: false,
    phoneMsg: false,
    // displayEmailMsg: false,
    // emailMsg: false,
    mobileMsg: false,
    displayPhoneMsg: false,
    displayPhoneValidationMessage: null,
    mobileValidationMessage: null,
    phoneValidationMessage: null,
    showOtpSectionMobile : false,    // showOtpSectionDisplayEmail: false,
    showOtpSectionDisplayPhone: false,
    skipMobileVerification: false,
    skipPhoneVerification: false,
  }),
  methods: {

  onlyAllowDigits(event) {
    const char = String.fromCharCode(event.which);
    if (!/[0-9]/.test(char)) {
      event.preventDefault();
    }
  },

  onlyAllowAlphanumeric(event) {
    const char = String.fromCharCode(event.which);
    if (!/[a-zA-Z0-9]/.test(char)) {
      event.preventDefault();
    }
  },

  removeTimer() {
   Cookies.remove("otp_logged_time");
 },
  

    checkCookies(){
if (Cookies.get('otp_logged_time') !== undefined) {
  return true
} 
else {

  return false
}
    },


getTimer(){

  if(this.checkCookies()){
    // this.$notify('Please wait for 10 minutes before sending another OTP', 'error')
    return false
  }

let cookieValue =Cookies.get('otp_logged_time')
        let remaining = Math.round(
            (cookieValue - new Date().getTime()) / 1000
        );

              this.remaningSecond = isNaN(remaining) ? 0 : remaining;



  if(remaining){
    // this.$notify('Please wait for 10 minutes before sending another OTP', 'error')
    return false
  }
  else{

    // this.$notify('otp can be send now', 'success');


    return true
  }

  },
    resetValidationState() {
      this.validationStatus = null;
      this.emailValidationMessage = null;
      this.phoneValidationMessage = null;
      this.emailMsg = false;
      this.phoneMsg = false;
      this.showOtpSectionEmail = false;
      this.showOtpSectionPhone = false;
      this.skipEmailVerification = false;
      this.skipMobileVerification = false;
      this.skipPhoneVerification = false;
      this.emailVerified = false;
      this.phoneVerified = false;
   
    },

  handleVerificationResult(result) {
  if (result.verified) {
    // Handle successful verification
    // This logic containig if and else if except else case needs to be refactor with better solution later
    // if(this.form.mobile_number == this.form.phone_number && this.form.mobile_number == this.form.display_phone){
    //   this.mobilemsg = true;
    //   this.phoneMsg = true;
    //   this.displayPhoneMsg = true;
    //   this.phoneVerified = true;
    //   this.skipPhoneVerification = true;
    //   this.skipMobileVerification =true;
    //   this.form.skip_validation_phone = this.skipPhoneVerification;
    //   this.form.skip_validation_mobile = this.skipMobileVerification;
    //   this.form.is_displayPhone = true;
    //   this.skipDisplayPhoneVerification = true;
    //   this.form.skip_validation_display_phone = this.skipDisplayPhoneVerification;
    //   this.mobileValidationMessage = {
    //     type: 'success',
    //     title: 'Success',
    //     message: 'Your phone has been verified!'
    //   };
    //   this.phoneValidationMessage = {
    //     type: 'success',
    //     title: 'Success',
    //     message: 'Your phone has been verified!'
    //   };
    //   this.displayPhoneValidationMessage = {
    //     type: 'success',
    //     title: 'Success',
    //     message: 'Your phone has been verified!'
    //   };
    //   this.showOtpSectionMobile = false;
    //   this.showOtpSectionPhone = false;
    //   this.showOtpSectionDisplayPhone = false;
      
    // } 
    // if(this.form.phone_number == this.form.mobile_number) {
    //   this.mobilemsg = true;
    //   this.phoneMsg = true;
    //   this.phoneVerified = true;
    //   this.skipPhoneVerification = true;
    //   this.skipMobileVerification =true;
    //   this.form.skip_validation_phone = this.skipPhoneVerification;
    //   this.form.skip_validation_mobile = this.skipMobileVerification;
    //   this.mobileValidationMessage = {
    //     type: 'success',
    //     title: 'Success',
    //     message: 'Your phone has been verified!'
    //   };
    //   this.phoneValidationMessage = {
    //     type: 'success',
    //     title: 'Success',
    //     message: 'Your phone has been verified!'
    //   };
    //   this.showOtpSectionMobile = false;
    //   this.showOtpSectionPhone = false;
    // } else if(this.form.phone_number == this.form.display_phone) {
    //   this.phoneMsg = true;
    //   this.displayPhoneMsg = true;
    //   this.phoneVerified = true;
    //   this.skipPhoneVerification = true;
    //   this.skipDisplayPhoneVerification = true;
    //   this.form.is_displayPhone = true;
    //   this.form.skip_validation_phone = this.skipPhoneVerification;
    //   this.form.skip_validation_display_phone = this.skipDisplayPhoneVerification;
    //   this.phoneValidationMessage = {
    //     type: 'success',
    //     title: 'Success',
    //     message: 'Your phone has been verified!'
    //   };
    //   this.displayPhoneValidationMessage = {
    //     type: 'success',
    //     title: 'Success',
    //     message: 'Your phone has been verified!'
    //   };
    //   this.showOtpSectionPhone = false;
    //   this.showOtpSectionDisplayPhone = false;
    // } else if(this.form.mobile_number == this.form.display_phone) {
    //   this.mobilemsg = true;
    //   this.displayPhoneMsg = true;
    //   this.skipMobileVerification =true;
    //   this.skipDisplayPhoneVerification = true;
    //   this.form.is_displayPhone = true;
    //   this.form.skip_validation_mobile = this.skipMobileVerification;
    //   this.form.skip_validation_display_phone = this.skipDisplayPhoneVerification;
    //   this.mobileValidationMessage = {
    //     type: 'success',
    //     title: 'Success',
    //     message: 'Your phone has been verified!'
    //   };
    //   this.displayPhoneValidationMessage = {
    //     type: 'success',
    //     title: 'Success',
    //     message: 'Your phone has been verified!'
    //   };
    //   this.showOtpSectionMobile = false;
    //   this.showOtpSectionDisplayPhone = false;

    // } else {
      if (result.type === 'phone') {
        switch(result.field) {
          case 'mobile':
            this.mobilemsg = true;
            this.skipMobileVerification =true;
            this.form.skip_validation_mobile = this.skipMobileVerification;
            this.mobileValidationMessage = {
              type: 'success',
              title: 'Success',
              message: 'Your phone has been verified!'
            };
            this.showOtpSectionMobile = false;
            break;
          case 'phone':
            this.phoneMsg = true;
            this.phoneVerified = true;
            this.skipPhoneVerification = true;
            this.form.skip_validation_phone = this.skipPhoneVerification;
            this.phoneValidationMessage = {
              type: 'success',
              title: 'Success',
              message: 'Your phone has been verified!'
            };
            this.showOtpSectionPhone = false;
            break;
          case 'display_phone':
            this.displayPhoneMsg = true;
            this.form.skip_validation_display_phone = this.skipDisplayPhoneVerification;
            this.displayPhoneValidationMessage = {
              type: 'success',
              title: 'Success',
              message: 'Your phone has been verified!'
            };
            this.showOtpSectionDisplayPhone = false;
            break;
          default:
            console.warn('Unknown field type:', result.field);
        }
      }
    // }
    this.$notify('Verification successful!');
  } 

},


// method to send the otp
  async sendOtp() {

    if(!this.getTimer()){
      // this.$notify('Please wait for 10 minutes before sending another OTP', 'error')
      return
    }   


      try {
        const response = await Api.post('v2/send-rep-otp', {
          contact: this.contactInfo,
          enrollment_id: this.$store.getters.regTempId,

          type: this.otpType,
        
        });
        if (response.data.success === true || response.data.status === 'success') {
      this.$notify('OTP sent successfully!');
    } else {
      this.$notify(response.data.message || 'Failed to send OTP. Please try again.', 'error');
      // this.showOtpSection = false;
    }
      } catch (error) {
        this.$notify('Failed to send OTP. Please try again.', 'error');
        // this.showOtpSection = false;
        console.error('OTP send error:', error);
      }
    },
    
    openOtpModal(type) {
      if (type === "mobile" && !this.form.mobile_number) {
        this.$notify("Please enter mobile number first.", "warning");
        return;
      }

      if (type === "phone" && !this.form.phone_number) {
        this.$notify("Please enter a Phone number first.", "warning");
        return;
      }
      if (type === "display_phone" && !this.form.display_phone) {
        this.$notify("Please enter a display Phone number first.", "warning");
        return;
      }

   

      if(type==="phone"){
        this.field="phone";
        this.contactInfo=this.form.phone_number;
        this.otpType = type;
     this.sendOtp();

      }
      if(type==="mobile"){
        this.field="mobile";
        this.contactInfo=this.form.mobile_number;
        this.otpType = "phone";
        
        this.sendOtp();

      }

      if(type==="display_phone"){
        this.field="display_phone";
        this.contactInfo=this.form.display_phone;
        this.otpType = 'phone';
        this.sendOtp();
      }
      // this.contactInfo = type === "email" ? this.form.email : this.form.cell_phone;
      this.showOtpModal = true;
      
    },


    // to close the otp modal
        closeOtpModal() {
      
      this.showOtpModal = false;
    },

    saveAndContinue() {
      this.$emit("onOpenSaveAndContinue", this.form);

    },
    backHandler() {
      this.$emit("onBackContactInfoForm");
    },

    handleInput(event, fieldName) {
      let inputValue = event.target.value;
      if (inputValue.length > 10) {
        inputValue = inputValue.slice(0, 10);
      }
      this.form[fieldName] = inputValue;
    },
    submit() {
      if (this.isChecked && this.form.display_phone) {
        this.fields[4].value = this.form.display_phone;
        this.form.is_displayPhone = true;
      } else {
        this.form.display_phone = "";
        this.form.is_displayPhone = false;
        this.isChecked = false;
      }
      this.form.registration_id = this.$store.getters.regTempId;
      this.form.savecont = false;
      let loader = this.$loading.show();
      let formData = this.form;
      ScreenShot.captureScreenShot(ScreenShot.regScreenShotSelector)
        .then((res) => {
          if (res) {
            formData["screenshot"] = res;
          }
        })
        .finally(() => {
          loader.hide();
          const url = "v2/registration/contact-info";
          this.save(url, formData);
        });
    },
    
    save(url, payload) {
this.phoneMsg = false;
this.mobileMsg = false;
this.displayPhoneMsg = false;
this.showOtpSectionPhone = false;
this.showOtpSectionMobile = false;
this.showOtpSectionDisplayPhone = false;
this.phoneValidationMessage = null;
this.mobileValidationMessage = null;
this.displayPhoneValidationMessage = null;

      let loader = this.$loading.show();
      axios
        .post(url, payload)
        .then(() => {
        this.removeTimer();
        this.skipMobileVerification = false;
        this.skipPhoneVerification = false;

          this.$emit("onSuccessContactInfoForm");
        })

        .catch((err) => {
          this.removeTimer();
          if (err.response.data.statusCode == 422) {
            this.apiErrors = err.response.data.errors;
              
            if(this.apiErrors.mobile_number) {
              let notificationMessage = '';
              this.skipMobileVerification = false;
              this.mobileMsg= true;
              if(this.apiErrors.mobile_number.includes("Mobile number already in use.")){
                notificationMessage = 'Mobile Number already in use';
              } else {
                this.showOtpSectionMobile = true;
                notificationMessage = 'Invalid Mobile Number - Please validate via OTP';
              }
              this.mobileValidationMessage = {
                type: 'error',
                title: 'Caution',
                message: notificationMessage
              };
            }

            if(this.apiErrors.display_phone){
              this.displayPhoneMsg = true;
              // this.showOtpSectionDisplayPhone = true;
              this.displayPhoneValidationMessage = {
                type: 'error',
                title: 'Caution',
                message: 'Invalid Phone - Please enter valid Phone number'
              };
            }

            if(this.apiErrors.phone_number) {
              let notificationMessage = '';
              this.skipPhoneVerification = false;
              this.phoneMsg= true;
              if(this.apiErrors.phone_number.includes("The phone number has already been taken.")){
                notificationMessage = 'Phone is already in use';
              } else {
                this.showOtpSectionPhone = true;
                notificationMessage = 'Invalid Phone - Please validate via OTP';
              }
              this.phoneValidationMessage = {
                type: 'error',
                title: 'Caution',
                message: notificationMessage
              };
            }

            this.$notify("Please enter the valid details", "error");

            // setTimeout(() => {
            //   if (this.apiErrors && this.fields && this.fields.length > 0) {
            //     const fieldsToKeep = [
            //       this.fields[2].field_name, 
            //       this.fields[4].field_name, 
            //       this.fields[1].field_name, 
            //     ];

            //     const newErrors = { ...this.apiErrors };
            //     Object.keys(newErrors).forEach((key) => {
            //       if (!fieldsToKeep.includes(key)) {
            //         delete newErrors[key];
            //       }
            //     });

            //     this.apiErrors = Object.keys(newErrors).length
            //       ? newErrors
            //       : null;
            //   }
            // }, 5000);
          } else {
            this.$notify(err.response.data.message, "error");
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
  },

  watch: {
    fields: {
      handler(newFields) {
        const isDisplayPhoneField = newFields.find(
          (field) => field.field_name === "is_displayPhone"
        );
        if (isDisplayPhoneField) {
          this.isChecked = isDisplayPhoneField.value === true;
        }
      },
      deep: true,
      immediate: true,
    },

     'form.mobile_number': {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.skipMobileVerification = false;
        this.removeTimer();
       this.mobileMsg = false;
        this.showOtpSectionMobile = false;
        this.mobileValidationMessage = null;
        // this.phoneVerified = false;
      }
    },
    immediate: true // To capture initial value
  },

  'form.phone_number': {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
       this.phoneMsg = false;
        this.phoneValidationMessage = null;
        this.skipPhoneVerification = false;
        this.removeTimer();
        this.showOtpSectionPhone = false;
        this.phoneVerified = false;
      }
    },
    immediate: true // To capture initial value
  },

  },

  created() {
    this.removeTimer();
    if (!this.$store.getters.regTempId) {
      this.backHandler();
    }
  },
};
</script>

<style>


.form-group {
  margin-bottom: 0.5rem;
}

.validate-message {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0.75rem 1rem;
  position: relative;
  margin-bottom: 0.75rem;
}

.message-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.message-text {
  flex-grow: 1;
  margin-left: 0.5rem;
  color: #495057;
}

.error-text {
  color: #dc3545;
  font-size: 0.875rem !important;
}

.success-text {
  color: #28a745;
}

.warning-text {
  color: #856404;
}

.error-indicator {
  background-color: #dc3545;
}

.success-indicator {
  background-color: #28a745;
}

.warning-indicator {
  background-color: #ffc107;
}

.button-verify-email {
  margin-top: 0;
  margin-bottom: 5px;
  font-size: 16px;
  border: none;
  background-color: transparent;
  color: rgb(5, 5, 139);
  text-decoration: underline;
  text-align: start;
}
.button-verify-phone{
  text-align: revert;
  margin-left: 98px;
}

.rep-mobile-otp-validation {
  border: 2px solid #e31717;
  width: 476px;
  padding: 5px;
  padding-left: 22px;
}

.rep-phone-otp-validation {
  border: 2px solid #e31717;
  width: 425px;
  padding: 5px;
  padding-left: 22px;
}

.rep-phone-otp-validation:hover, .rep-mobile-otp-validation:hover {
  border: 2px solid #a50e0e;
  box-shadow: #eb2a2a;
  background-color: aliceblue;
  cursor: pointer;
}
</style>
